
import TableList from "@components/templates/tablelist";
import compUpdate from "./update.vue";
import {
    HttpGetCarrierServiceList,
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        compUpdate,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
        };
    },
    methods: {
        ajaxRequest: HttpGetCarrierServiceList,
        exportQuery() {
            let searchData = {}
            Object.keys(this.formData.search).map(item => {
                searchData[`search[${item}]`] = this.formData.search[item]
            });
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/carrierVolumeWeight/batchExport", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                // this.$VMessage.error(err.message);
            });
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 800,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    };
                    break;
                case 'exportQuery':
                    this.exportQuery(params);
                    break
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'add',
                        showFooter: false
                    }
                    break;
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'edit',
                        showFooter: false
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: "查看" }),
                    show: true,
                    params: id,
                    operate: "query"
                },
                {
                    label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                    show: this.handleAuth('fbb.groupservice.edit'),
                    params: id,
                    operate: 'edit'
                }]
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
            "getCarrierServiceList",
            "getAlllogProCodeList",
            "getCountryList"
        ]),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    show: this.handleAuth('fbb.groupservice.add'),
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'exportQuery',
                    show: this.handleAuth('fbb.groupservice.export'),
                    theme: 'success'
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 250px'
            return [
                {
                    label: this.$t('fbb.carrieraccount.logistics_carrier', { defaultValue: '物流产品' }),
                    tag: 'vSelect',
                    show: true,
                    key: 'IN_carrierGroupId',
                    options: this.getAlllogProCodeList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                },
                {
                    label: this.$t('', { defaultValue: '物流服务代码' }),
                    tag: 'Input',
                    show: true,
                    key: 'CN_code',
                },
                {
                    label: this.$t('fbb.carrieraccount.carrieraccount_service', { defaultValue: '承运商服务' }),
                    tag: 'Select',
                    show: true,
                    key: 'IN_carrierServiceId',
                    options: this.carrierServiceList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                }
            ]
        },
        columns() {
            return [
                {
                    // show: false,
                    type: 'index',
                    width: 40,
                    align: 'center',
                }, {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                },
                {
                    title: this.$t('fbb.carrieraccount.logistics_carrier', { defaultValue: '物流产品' }),
                    key: 'carrierGroupName'
                },
                {
                    title:this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    key:'regionCode',
                    render:(h,{row})=>{
                        const region=this.getCountryList.filter(item=>item.value===row.regionCode)[0]
                        return (
                            <div>{region ? region.label : '--'}</div>
                        )
                    }
                },
                {
                    title: this.$t('fbb.carrieraccount.carrieraccount_service', { defaultValue: '承运商服务' }),
                    render: (h, { row }) => {
                        let serviceItem = this.getCarrierServiceList.filter(item => {
                            return item.value === row.carrierServiceId
                        })[0];
                        return <div>{serviceItem ? serviceItem.label : '--'}</div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: '物流服务代码' }),
                    key: 'code',
                    render: (h, { row }) => {
                        return <div>{row.code}</div>
                    }
                },

                {
                    title: this.$t('fbb.basicdata.carrier_volume', { defaultValue: '体积重系数' }),
                    key: 'volumeWeight'
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    // width: 130
                }
            ];
        },

    }

};
